import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  showUpdate,
  remove,
  getList,
  getControladorList,
  updateDataEspecialControlador,
  createUpdateDataEspecialControlador,
  removeDataEspecialControlador,
  copiarDatasEspeciaisControladores,
  updateDataEspecialControladorGeral,
  setPaginaAtual,
} from './dataEspecialActions';
import SPButton from '../common/form/spButton';
import { toastr } from 'react-redux-toastr';

import ReactTableGT2A from '../common/grid/gridReactTable';
import PremiumTableShell from '../common/grid/premiumTableShell';
import ButtonTooltip from '../common/form/buttonTooltip';
import ActionConfirmModal from '../common/components/actionConfirmModal';
import ProcessingOverlay from '../common/components/processingOverlay';
import If from '../common/operator/if';
import PermissaoUsuario from '../auth/permissao';

function DataEspecialEmptyState() {
  return (
    <div className="data-especial-empty-state">
      <div className="data-especial-empty-state__icon">
        <i className="fa fa-calendar-alt" aria-hidden="true" />
      </div>
      <strong>Nenhuma data especial cadastrada</strong>
      <span>Use a aba Incluir para cadastrar ou leia do controlador para importar as configurações.</span>
    </div>
  );
}

class DataEspecialList extends Component {
  constructor(props) {
    super(props);

    this.lerDataEspecialControlador = this.lerDataEspecialControlador.bind(this);
    this.salvarDataEspecialControlador = this.salvarDataEspecialControlador.bind(this);
    this.salvarControladorDB = this.salvarControladorDB.bind(this);
    this.lerDataEspecialSistema = this.lerDataEspecialSistema.bind(this);
    this.removerDatasEspeciais = this.removerDatasEspeciais.bind(this);
    this.alterarDatasEspeciais = this.alterarDatasEspeciais.bind(this);
    this.copiarDadosControladores = this.copiarDadosControladores.bind(this);
    this.confirmarExclusao = this.confirmarExclusao.bind(this);
    this.cancelarExclusao = this.cancelarExclusao.bind(this);
    this.confirmarEnviarControlador = this.confirmarEnviarControlador.bind(this);
    this.cancelarEnviarControlador = this.cancelarEnviarControlador.bind(this);
    this.confirmarSalvarSistema = this.confirmarSalvarSistema.bind(this);
    this.cancelarSalvarSistema = this.cancelarSalvarSistema.bind(this);
    this.confirmarEnviarTodos = this.confirmarEnviarTodos.bind(this);
    this.cancelarEnviarTodos = this.cancelarEnviarTodos.bind(this);

    this.intervalGetList = 0;

    this.state = {
      salvarDB: false,
      confirmExclusao: null,
      confirmEnviarControlador: false,
      confirmEnviarTodos: false,
      confirmSalvarSistema: false,
      processingGeral: false,
      processingMessage: '',
      processingDetail: '',
    };
  }

  startProcessing(message, detail = '') {
    this.setState({
      processingGeral: true,
      processingMessage: message,
      processingDetail: detail,
    });
  }

  stopProcessing(extraState = {}) {
    this.setState({
      processingGeral: false,
      processingMessage: '',
      processingDetail: '',
      ...extraState,
    });
  }

  formatDataEspecial(original) {
    const now = new Date();
    const y = now.getFullYear();
    const m = now.getMonth() + 1;
    const d = now.getDate();
    const selM = Number(original.mes);
    const selD = Number(original.dia);
    const nextYear = selM < m || (selM === m && selD < d);
    const ano = nextYear ? y + 1 : y;
    const dia = String(selD).padStart(2, '0');
    const mes = String(selM).padStart(2, '0');

    return `${dia}/${mes}/${ano}`;
  }

  handlePageChange = page => {
    this.props.setPaginaAtual(page);
  };

  componentWillUnmount() {
    clearInterval(this.intervalGetList);
  }

  lerDataEspecialControlador() {
    this.startProcessing('Lendo datas especiais do controlador...', 'Comunicando com a central e o equipamento.');

    this.props
      .getControladorList()
      .then(result => {
        this.stopProcessing();

        if (result.error) {
          toastr.error('Erro', result.payload.response.data.errors[0]);
          this.props.getList();
        } else {
          toastr.success('Sucesso', 'Operação realizada com sucesso.');
          this.setState({ salvarDB: true });
        }
      })
      .catch(e => {
        this.stopProcessing();
        toastr.error('Erro', e.response.data.errors[0]);
        this.props.getList(this.props['data-controlador'], this.props['data-plano']);
      });
  }

  lerDataEspecialSistema() {
    this.props.getList();
    this.setState({ salvarDB: false });
  }

  salvarDataEspecialControlador() {
    this.setState({ confirmEnviarControlador: true });
  }

  cancelarEnviarControlador() {
    this.setState({ confirmEnviarControlador: false });
  }

  confirmarEnviarControlador() {
    this.setState({ confirmEnviarControlador: false });
    const data = this.props.list || [];

    this.startProcessing('Enviando datas especiais ao controlador...', 'Aguarde, este processo pode levar algum tempo.');

    this.props
      .updateDataEspecialControlador(data)
      .then(result => {
        this.stopProcessing();
        if (result.error) {
          toastr.error('Erro', result.payload.response.data.errors[0]);
        } else {
          toastr.success('Sucesso', 'Datas especiais enviadas com sucesso.');
        }
      })
      .catch(e => {
        this.stopProcessing();
        toastr.error('Erro', e.response.data.errors[0]);
      });
  }

  salvarControladorDB() {
    this.setState({ confirmSalvarSistema: true });
  }

  cancelarSalvarSistema() {
    this.setState({ confirmSalvarSistema: false });
  }

  confirmarSalvarSistema() {
    this.setState({ confirmSalvarSistema: false });
    const data = this.props.list || [];

    this.startProcessing('Salvando datas no sistema...', 'Substituindo os dados atuais pelos lidos do controlador.');

    this.props
      .removeDataEspecialControlador()
      .then(result => {
        if (result.error) {
          this.stopProcessing();
          toastr.error('Erro', result.payload.response.data.errors[0]);
        } else if (data.length > 0) {
          const savePromises = data.map(item => this.props.createUpdateDataEspecialControlador(item));
          return Promise.all(savePromises).then(() => {
            this.props.getList();
            this.stopProcessing({ salvarDB: false });
            toastr.success('Sucesso', 'Dados sincronizados com o controlador.');
          });
        } else {
          this.props.getList();
          this.stopProcessing({ salvarDB: false });
          toastr.success('Sucesso', 'Datas especiais removidas (controlador sem datas).');
        }
      })
      .catch(e => {
        this.stopProcessing();
        toastr.error('Erro', e.message || 'Erro ao salvar no sistema');
      });
  }

  alterarDatasEspeciais(data) {
    if (this.state.salvarDB) {
      toastr.warning('Atenção', 'Só é possível alterar depois de gravar os dados do controlador no sistema.');
    } else {
      this.props.showUpdate(data);
    }
  }

  async removerDatasEspeciais(data) {
    if (this.state.salvarDB) {
      toastr.warning('Atenção', 'Só é possível excluir depois de gravar os dados do controlador no sistema.');
      return;
    }

    this.setState({ confirmExclusao: { data } });
  }

  async confirmarExclusao() {
    const { confirmExclusao } = this.state;
    if (!confirmExclusao) return;

    const { data } = confirmExclusao;
    this.setState({ confirmExclusao: null });

    const html2canvas = (await import('html2canvas')).default;
    const canvas = await html2canvas(document.querySelector('.content'));
    const imageLog = canvas.toDataURL('png');
    const dataComImagem = { ...data, imageLog };
    this.props.remove(dataComImagem);
  }

  cancelarExclusao() {
    this.setState({ confirmExclusao: null });
  }

  copiarDadosControladores() {
    this.setState({ confirmEnviarTodos: true });
  }

  cancelarEnviarTodos() {
    this.setState({ confirmEnviarTodos: false });
  }

  confirmarEnviarTodos() {
    this.setState({ confirmEnviarTodos: false });
    const data = this.props.list || [];

    this.startProcessing(
      'Enviando datas especiais para os controladores...',
      'Replicando configurações do grupo físico.',
    );

    this.props
      .copiarDatasEspeciaisControladores()
      .then(result => {
        if (!result.error) {
          this.props
            .updateDataEspecialControladorGeral(data)
            .then(result2 => {
              this.stopProcessing();
              if (result2.error) {
                toastr.warning('Atenção', result2.payload.response.data || 'Falha ao atualizar controladores');
              } else {
                toastr.success('Sucesso', 'Operação realizada com sucesso.');
              }
            })
            .catch(e2 => {
              this.stopProcessing();
              toastr.warning(
                'Atenção',
                e2.response && e2.response.data && e2.response.data.errors
                  ? e2.response.data.errors.join('<br />')
                  : 'Falha ao atualizar controladores',
              );
            });
        } else {
          this.stopProcessing();
          toastr.warning('Atenção', result.payload.response.data || 'Falha ao realizar a cópia dos dados');
        }
      })
      .catch(e => {
        this.stopProcessing();
        toastr.warning(
          'Atenção',
          e.response && e.response.data && e.response.data.errors
            ? e.response.data.errors.join('<br />')
            : 'Falha ao realizar a cópia dos dados',
        );
      });
  }

  render() {
    const dataEspecial = this.props.list || [];
    const paginaAtual = this.props.paginaAtual;
    const {
      confirmExclusao,
      confirmEnviarControlador,
      confirmEnviarTodos,
      confirmSalvarSistema,
      processingGeral,
      processingMessage,
      processingDetail,
    } = this.state;

    const columns = [
      {
        Header: 'Ações',
        Cell: row => (
          <div className="data-especial-actions-cell">
            <PermissaoUsuario tela="CadDataEspecial" condicao={true}>
              <div className="data-especial-actions-group">
                <SPButton
                  type="button"
                  className="warning btn-sm"
                  icon="pencil-alt"
                  data-title="Alterar"
                  onClick={() => this.alterarDatasEspeciais(row.original)}
                />
                <SPButton
                  type="button"
                  className="danger btn-sm"
                  icon="trash-alt"
                  data-title="Excluir"
                  onClick={() => this.removerDatasEspeciais(row.original)}
                />
              </div>
            </PermissaoUsuario>
            <PermissaoUsuario tela="CadDataEspecial" condicao={false}>
              <div className="data-especial-actions-group">
                <SPButton type="button" className="warning btn-sm" icon="pencil-alt" disabled="disabled" />
                <SPButton type="button" className="danger btn-sm" icon="trash-alt" disabled="disabled" />
              </div>
            </PermissaoUsuario>
          </div>
        ),
        width: 104,
        filterable: false,
        resizable: true,
        className: 'column_icon',
      },
      {
        Header: 'Plano',
        accessor: 'plano_id',
        width: 85,
        className: 'column_grid column_center',
        filterable: false,
        resizable: true,
      },
      {
        Header: 'Data',
        id: 'dataCompleta',
        className: 'column_grid column_center',
        width: 120,
        resizable: true,
        filterable: false,
        Cell: ({ original }) => this.formatDataEspecial(original),
      },
      {
        Header: 'Hora Inicial',
        accessor: 'horario_inicial',
        className: 'column_grid column_center',
        width: 120,
        resizable: true,
        filterable: false,
        Cell: ({ value }) => (value ? value.substring(0, 5) : ''),
      },
      {
        Header: 'Hora Final',
        accessor: 'horario_final',
        className: 'column_grid column_center',
        width: 120,
        resizable: true,
        filterable: false,
        Cell: ({ value }) => (value ? value.substring(0, 5) : ''),
      },
    ];

    return (
      <div>
        <ProcessingOverlay
          show={processingGeral}
          message={
            processingMessage ? (
              <>
                {processingMessage}
                {processingDetail ? <small>{processingDetail}</small> : null}
              </>
            ) : (
              'Aguarde…'
            )
          }
          tagline="Datas Especiais"
        />
        <ActionConfirmModal
          show={!!confirmExclusao}
          title="Deseja realmente excluir?"
          message="A data especial será removida permanentemente do sistema."
          itemName={
            confirmExclusao && confirmExclusao.data ? this.formatDataEspecial(confirmExclusao.data) : ''
          }
          itemDetail={
            confirmExclusao && confirmExclusao.data
              ? `Plano ${confirmExclusao.data.plano_id} · ${confirmExclusao.data.horario_inicial || ''} às ${confirmExclusao.data.horario_final || ''}`
              : ''
          }
          confirmLabel="Excluir"
          destructive
          icon="trash-alt"
          onConfirm={this.confirmarExclusao}
          onCancel={this.cancelarExclusao}
        />
        <ActionConfirmModal
          show={confirmEnviarControlador}
          title="Enviar datas especiais para o controlador?"
          message="Essa ação vai substituir as configurações existentes no controlador."
          itemName={`${dataEspecial.length} data(s) especial(is)`}
          itemDetail="Controlador selecionado"
          confirmLabel="Enviar"
          icon="upload"
          onConfirm={this.confirmarEnviarControlador}
          onCancel={this.cancelarEnviarControlador}
        />
        <ActionConfirmModal
          show={confirmSalvarSistema}
          title="Substituir os dados atuais do sistema?"
          message="Os dados lidos do controlador substituirão as datas especiais cadastradas no sistema."
          itemName={`${dataEspecial.length} data(s) lida(s) do controlador`}
          itemDetail="Dados atuais do sistema serão removidos"
          confirmLabel="Sim, salvar"
          icon="save"
          onConfirm={this.confirmarSalvarSistema}
          onCancel={this.cancelarSalvarSistema}
        />
        <ActionConfirmModal
          show={confirmEnviarTodos}
          title="Enviar para todos os controladores do grupo físico?"
          message="Essa ação vai substituir as configurações existentes nos controladores do mesmo grupo físico."
          itemName={`${dataEspecial.length} data(s) especial(is)`}
          itemDetail="Grupo físico do controlador"
          confirmLabel="Enviar para todos"
          icon="copy"
          onConfirm={this.confirmarEnviarTodos}
          onCancel={this.cancelarEnviarTodos}
        />

        <style>{`
          .data-especial-actions-cell {
            display: flex;
            justify-content: center;
            width: 100%;
          }

          .data-especial-actions-group {
            display: inline-flex;
            align-items: center;
            gap: 4px;
            padding: 2px;
          }

          .data-especial-actions-group .btn {
            border-radius: 9px !important;
            min-width: 28px;
            width: 28px;
            height: 28px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border: 0 !important;
            box-shadow: none !important;
            padding: 0 !important;
            font-size: 12px !important;
          }

          .data-especial-actions-group .btn.warning {
            background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%) !important;
            color: #ffffff !important;
          }

          .data-especial-actions-group .btn.danger {
            background: linear-gradient(135deg, #f87171 0%, #ef4444 100%) !important;
            color: #ffffff !important;
          }

          .data-especial-premium-table .ReactTable .rt-th.column_center,
          .data-especial-premium-table .ReactTable .rt-td.column_center,
          .data-especial-premium-table .ReactTable .rt-th.column_icon,
          .data-especial-premium-table .ReactTable .rt-td.column_icon {
            justify-content: center;
            text-align: center;
          }

          .data-especial-empty-state {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 8px;
            padding: 48px 24px;
            color: #64748b;
            text-align: center;
          }

          .data-especial-empty-state__icon {
            width: 56px;
            height: 56px;
            border-radius: 16px;
            background: linear-gradient(135deg, rgba(60, 141, 188, 0.12) 0%, rgba(60, 141, 188, 0.06) 100%);
            color: #3c8dbc;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 24px;
            margin-bottom: 4px;
          }

          .data-especial-empty-state strong {
            color: #334155;
            font-size: 16px;
            font-weight: 700;
          }

          .data-especial-empty-state span {
            max-width: 360px;
            font-size: 13px;
            line-height: 1.5;
          }

          .data-especial-footer {
            display: flex;
            align-items: flex-start;
            gap: 12px;
            flex-wrap: wrap;
            padding-top: 12px;
          }

          .data-especial-footer-left {
            display: flex;
            gap: 12px;
            flex-wrap: wrap;
          }

          .data-especial-footer-right {
            margin-left: auto;
          }

          .data-especial-footer .btn {
            border-radius: 12px !important;
            min-height: 40px;
            padding: 0 16px !important;
            border: 0 !important;
            font-weight: 600;
            box-shadow: 0 10px 20px rgba(15, 23, 42, 0.08) !important;
          }

          .data-especial-footer .btn.success {
            background: linear-gradient(135deg, #5fa8d3 0%, #3d8ec3 100%) !important;
            color: #ffffff !important;
          }

          .data-especial-footer .btn.primary {
            background: linear-gradient(135deg, #4f8fb8 0%, #2f6f98 100%) !important;
            color: #ffffff !important;
          }

          .data-especial-footer .btn.warning {
            background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%) !important;
            color: #ffffff !important;
          }
        `}</style>

        <div className="data-especial-premium-table">
          <PremiumTableShell summary={`${dataEspecial.length} data(s) especial(is) carregada(s)`} tableMinWidth={760}>
            <ReactTableGT2A
              data={dataEspecial}
              columns={columns}
              showFilters={false}
              className="-striped -highlight"
              defaultPageSize={15}
              minRows={0}
              onPageChange={this.handlePageChange}
              page={paginaAtual}
              NoDataComponent={DataEspecialEmptyState}
            />
          </PremiumTableShell>
        </div>
        <div className="data-especial-footer">
          <div className="data-especial-footer-left">
            <PermissaoUsuario tela="CadDataEspecial" condicao={true}>
              <ButtonTooltip
                type="button"
                id="btnDataLerControlador"
                className="success"
                icon="download"
                label="Ler do Controlador"
                data-title="Busca os dados do controlador"
                onClick={this.lerDataEspecialControlador}
              />
            </PermissaoUsuario>
            <PermissaoUsuario tela="CadDataEspecial" condicao={false}>
              <ButtonTooltip
                type="button"
                id="btnDataLerControlador"
                className="success"
                icon="download"
                label="Ler do Controlador"
                disabled="disabled"
              />
            </PermissaoUsuario>

            <PermissaoUsuario tela="CadDataEspecial" condicao={true}>
              <ButtonTooltip
                type="button"
                id="btnDataEnviarControlador"
                className="primary"
                icon="upload"
                label="Enviar para esse Controlador"
                data-title="Envia os dados para o controlador"
                onClick={this.salvarDataEspecialControlador}
              />
            </PermissaoUsuario>
            <PermissaoUsuario tela="CadDataEspecial" condicao={false}>
              <ButtonTooltip
                type="button"
                id="btnDataEnviarControlador"
                className="primary"
                icon="upload"
                label="Enviar para esse Controlador"
                disabled="disabled"
              />
            </PermissaoUsuario>

            <If condicao={this.state.salvarDB}>
              <>
                <PermissaoUsuario tela="CadDataEspecial" condicao={true}>
                  <ButtonTooltip
                    type="button"
                    id="btnDataSalvarDB"
                    className="primary"
                    icon="check"
                    label="Salvar no sistema"
                    data-title="Salva no sistema os dados que vieram do controlado"
                    onClick={this.salvarControladorDB}
                  />
                </PermissaoUsuario>
                <PermissaoUsuario tela="CadDataEspecial" condicao={false}>
                  <ButtonTooltip
                    type="button"
                    id="btnDataSalvarDB"
                    className="primary"
                    icon="check"
                    label="Salvar no sistema"
                    disabled="disabled"
                  />
                </PermissaoUsuario>
              </>
            </If>

            <If condicao={this.state.salvarDB}>
              <>
                <PermissaoUsuario tela="CadDataEspecial" condicao={true}>
                  <ButtonTooltip
                    type="button"
                    id="btnDataEspLerSistema"
                    className="primary"
                    icon="file-download"
                    label="Ler do sistema"
                    data-title="Busca os dados do banco de dados do sistema"
                    onClick={this.lerDataEspecialSistema}
                  />
                </PermissaoUsuario>
                <PermissaoUsuario tela="CadDataEspecial" condicao={false}>
                  <ButtonTooltip
                    type="button"
                    id="btnDataEspLerSistema"
                    className="primary"
                    icon="file-download"
                    label="Ler do sistema"
                    disabled="disabled"
                  />
                </PermissaoUsuario>
              </>
            </If>
          </div>

          <div className="data-especial-footer-right">
            <PermissaoUsuario tela="CadDataEspecial" condicao={true}>
              <ButtonTooltip
                type="button"
                id="btnDataReplicarDataEspecial"
                className="warning"
                icon="copy"
                label="Enviar para Todos os Controladores"
                data-title="Replica as datas especiais para os controladores do grupo físico"
                onClick={this.copiarDadosControladores}
              />
            </PermissaoUsuario>
            <PermissaoUsuario tela="CadDataEspecial" condicao={false}>
              <ButtonTooltip
                type="button"
                className="warning"
                icon="copy"
                label="Enviar para Todos os Controladores"
                disabled
              />
            </PermissaoUsuario>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  list: state.dataEspecialCad.list,
  paginaAtual: state.dataEspecialCad.paginaAtual,
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      showUpdate,
      remove,
      getList,
      getControladorList,
      updateDataEspecialControlador,
      createUpdateDataEspecialControlador,
      removeDataEspecialControlador,
      copiarDatasEspeciaisControladores,
      updateDataEspecialControladorGeral,
      setPaginaAtual,
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DataEspecialList);
